import { useRouter } from 'next/router';
import useSWR, { KeyedMutator } from 'swr';
import { customSWRResponse, Languages } from '../model/types';
import { isPublicPage } from '../utils/routeHelper';
import useSWRCacheKeys from './useSWRCacheKeys';

export default function useUserLanguage(): customSWRResponse<Languages> {
    const { pathname } = useRouter();
    const keys = useSWRCacheKeys(isPublicPage(pathname) ? null : '/users/language');

    const { data, isLoading, mutate } = useSWR<Languages>(keys, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });

    return {
        data,
        isLoading,
        mutate: mutate as unknown as KeyedMutator<Languages>
    };
}
